import { IPayloadWrapper } from "../types/PayloadWrapper";
import Constants from "../../boxReview/Constants";
export const SET_BOX_REVIEW_MODEL = "automatpacken/boxReview/SET_BOX_REVIEW_MODEL";
export const SET_ORDER_SHIPPING_METHOD = "automatpacken/boxReview/SET_ORDER_SHIPPING_METHOD";
export const SET_CURRENT_BOX = "automatpacken/boxReview/SET_CURRENT_BOX";
export const BOX_REVIEW_STATE_CLEAR = "automatpacken/boxReview/BOX_REVIEW_STATE_CLEAR";
export const SET_BOX_REVIEW_ACTION = "automatpacken/boxReview/SET_REVIEW_BOX_ACTION";
export const SET_BOX_WAS_UPDATED = "automatpacken/boxReview/SET_BOX_WAS_UPDATED";
export const SET_DATA_URLS = "automatpacken/boxReview/SET_IMAGE_URL";
export const SET_IMAGE_DATA = "automatpacken/boxReview/SET_IMAGE_DATA";
export const SET_STOCK = "automatpacken/boxReview/SET_STOCK";
export const CLEAR_URLS_AND_DATA = "automatpacken/boxReview/CLEAR_URLS_AND_DATA";
export const SET_WRONG_LABEL_MODAL_STATUS = "automatpacken/boxReview/SET_WRONG_LABEL_MODAL_STATUS";
export const SET_FORCE_ACTION = "automatpacken/boxReview/SET_FORCE_ACTION";
export const SET_ERROR_DATA = "automatpacken/boxReview/SET_ERROR_DATA";
export const SET_CURRENT_ORDER_LOOKUP_VALUE = "automatpacken/boxReview/SET_CURRENT_ORDER_LOOKUP_VALUE";
export const SWITCH_TO_DELIVERY = "automatpacken/boxReview/SWITCH_TO_DELIVERY";
export const SET_SHIPPING_METHODS = "automatpacken/boxReview/SET_SHIPPING_METHODS";
export const LOAD_BOX_REVIEW_ORDER = "automatpacken/boxReview/LOAD_BOX_REVIEW_ORDER";
export const LOAD_SHIPPING_METHODS = "automatpacken/boxReview/LOAD_SHIPPING_METHODS";
export const LOAD_IPACK_IMAGES = "automatpacken/boxReview/LOAD_IPACK_IMAGES";
export const SET_BOX_REVIEW_MODEL_ITEMS = "automatpacken/boxReview/SET_BOX_REVIEW_MODEL_ITEMS";

const { ActionStates } = Constants;

export const setBoxReviewAction = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_BOX_REVIEW_ACTION,
    payload
  };
};

export const setBoxReviewModelItems = (payload: { items: any}) => {
  return {
    type: SET_BOX_REVIEW_MODEL_ITEMS,
    payload
  }
}

export const setBoxReviewModel = (payload: { sortBox: any; callback: (() => void) | null }) => {
  return {
    type: SET_BOX_REVIEW_MODEL,
    payload,
  };
};

export const setOrderShippingMethod = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_ORDER_SHIPPING_METHOD,
    payload,
  };
};

export const setCurrentBox = (payload: { box: any; callback: (() => void) | null }) => {
  return {
    type: SET_CURRENT_BOX,
    payload,
  };
};

export const clearBoxReviewState = () => {
  return {
    type: BOX_REVIEW_STATE_CLEAR,
  };
};

export const reloadBoxReview = (payload: IPayloadWrapper<boolean> ) => {
  return {
    type: SET_BOX_WAS_UPDATED,
    payload
  };
};

export const setURLs = (payload: { imageURL: string | boolean,  labelURL: string | boolean } ) => {
  return {
    type: SET_DATA_URLS,
    payload
  };
};

export const setImageData = (payload: { imageBytes: any, imageFound: boolean }) => {
  
  return {
    type: SET_IMAGE_DATA,
    payload
  };
};

export const setStock = (payload: { data: any }) => {
  
  return {
    type: SET_STOCK,
    payload
  };
};

export const clearURLsAndData = () => {
  return {
    type: CLEAR_URLS_AND_DATA,
  };
};

export const setWrongLabelModalStatus = (payload: IPayloadWrapper<boolean>)  => {
  return {
    type: SET_WRONG_LABEL_MODAL_STATUS,
    payload
  };
};

export const setForceAction = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_FORCE_ACTION,
    payload
  };
};

export const setErrorData = (payload: { showInfoModal: boolean, infoMessage: string, currentError: string }) => {
  return {
    type: SET_ERROR_DATA,
    payload
  };
};

export const setCurrentOrderLookupValue = (payload: IPayloadWrapper<string>) => {
  return {
    type: SET_CURRENT_ORDER_LOOKUP_VALUE,
    payload
  };
};

export const switchToDelivery = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SWITCH_TO_DELIVERY,
    payload
  };
};

export const setShippingMethods = (payload: Array<any>) => {
  return {
    type: SET_SHIPPING_METHODS,
    payload
  }
}

export const loadBoxReviewOrder = (payload: { inputValue: string, switchToDelivery: boolean }) => {
  return {
    type: LOAD_BOX_REVIEW_ORDER,
    payload
  }
}

export const loadIPackImages = () => {
  return {
    type: LOAD_IPACK_IMAGES,
  }
}

export const loadShippingMethods = () => {
  return {
    type: LOAD_SHIPPING_METHODS
  }
}


const initialBoxReviewState: IBoxReviewState = {
  sortBoxModel: null,
  currentBox: null,
  orderShippingMethod: -1,
  boxReviewAction: ActionStates.LOAD_BOX,
  boxWasUpdated: false,
  labelUrl: "",
  imageUrl: "",
  imageBytes: [],
  imageFound: false,
  wrongLabelModalOpen: false,
  showInfoModal: false,
  infoMessage: "",
  currentOrderLookupValue: "",
  shippingMethods: [],
  currentError: "",
  isLoading: false,
  forceAction: false,
  stock: []
};

interface IBoxReviewState {
  stock: any,
  sortBoxModel: any,
  currentBox: any,
  orderShippingMethod: number,
  boxReviewAction: number,
  boxWasUpdated: boolean,
  labelUrl: string | boolean,
  imageUrl: string | boolean,
  imageBytes: any,
  imageFound: boolean,
  wrongLabelModalOpen: boolean,
  showInfoModal: boolean,
  infoMessage: string,
  currentOrderLookupValue: string,
  shippingMethods: Array<any>,
  currentError: string,
  isLoading: boolean
  forceAction: boolean
}

const reducer = (state = initialBoxReviewState, action: any) : IBoxReviewState => {
  switch (action.type) {
    case SET_BOX_REVIEW_MODEL:
      return { ...state, sortBoxModel: action.payload.sortBox };
    case SET_BOX_REVIEW_MODEL_ITEMS:
      return { ...state, sortBoxModel: { ...state.sortBoxModel, sortBoxItems: action.payload }}
    case SET_ORDER_SHIPPING_METHOD:
      return { ...state, orderShippingMethod: action.payload.value };
    case SET_CURRENT_BOX:
      return { ...state, currentBox: action.payload.box };
    case BOX_REVIEW_STATE_CLEAR:
      return { ...state, ...initialBoxReviewState };
    case SET_BOX_REVIEW_ACTION: 
      return { ...state, boxReviewAction: action.payload.value }
    case SET_BOX_WAS_UPDATED: 
      return { ...state, boxWasUpdated: action.payload.value }
    case SET_DATA_URLS: 
      return { ...state, imageUrl: action.payload.imageURL, labelUrl: action.payload.labelURL }
    case SET_IMAGE_DATA: 
      return { ...state, imageFound: action.payload.imageFound, imageBytes: action.payload.imageBytes }
    case SET_STOCK: 
      return { ...state, stock: action.payload.data,  }
    case CLEAR_URLS_AND_DATA: 
      return { ...state, imageBytes: [], imageFound: false, labelUrl: "", imageUrl: ""}
    case SET_WRONG_LABEL_MODAL_STATUS: 
      return { ...state, wrongLabelModalOpen: action.payload.value }
    case SET_FORCE_ACTION: 
      return { ...state, forceAction: action.payload.value }
    case SET_ERROR_DATA:  
      return { ...state, ...action.payload }
    case SET_CURRENT_ORDER_LOOKUP_VALUE:
      return { ...state, currentOrderLookupValue: action.payload.value }
    case SET_SHIPPING_METHODS:
      return { ...state, shippingMethods:  action.payload }
    default:
      return state;
  }
};

export default reducer;
